import { $, _, Obscura, Backbone, Foundation, moment, Radio } from "../../../../vendor";

import { Notification, Biscuit, FormatHelper } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";

import Contingents from "../../../collections/Contingents";

import ContingentsOverviewModalTpl from "../../../templates/orders/ReservationForm/ContingentsOverviewModalTpl.html";
import ContingentsOverviewItemTpl from "../../../templates/orders/ReservationForm/ContingentsOverviewItemTpl.html";
import ProductsOverviewModalTpl from "../../../templates/orders/ReservationForm/ProductsOverviewModalTpl.html";
import ProductsOverviewItemTpl from "../../../templates/orders/ReservationForm/ProductsOverviewItemTpl.html";
import Products from "../../../collections/Products";
import { getContentModifications } from "../../../App";

const ContingentsOverviewItemContingentSelect = InboomaBaseView.extend({
  template: _.template(`
        <div class="input-group<%- (warning !== null ? ' warning' : '') %>">
        <% if (amount.available == 'Contingent is not available' || amount.available == 'not available because no contingent number is configured'){ %>
           <span>
           <% 
           let inf = '';
           if (size != '') { 
                    inf += size.replace('(','').replace(')','') +": ";
           } 
           let str = t(amount.available);
           inf += str;
            %><%- str %></span>
           <% } else { %>
            <select class="contingents-overview-item__chosen-amount-input input-group-field">
            <% for (var i = 0; i < (amount.available + 1); i++) { %>
                <option value="<%- i %>"<%- (amount.chosen === i ? ' selected="selected"' : '') %>>
                    <% if (size != '') { %>
                    <%- size.replace('(','').replace(')','') %>: 
                    <% } %>
                    <%- i %>
                </option>
            <% } %>
            </select>
            <span class="input-group-label">
            / <%- amount.available %>
            </span>
            <% } %>
        </div>
    `),

  templateContext() {
    return {
      size: FormatHelper.formatContingentTags(this.model.get("tags")),
    };
  },

  ui: {
    chosenAmountInput: ".contingents-overview-item__chosen-amount-input",
  },

  events: {
    "change @ui.chosenAmountInput": "_updateChosenAmount",
  },

  _updateChosenAmount() {
    const chosenAmount = this.getUI("chosenAmountInput").val();
    let parentId = "#parent_select_" + this.model.get("name").replace(/[^a-zA-Z0-9]/g, "");
    if (
      typeof chosenAmount !== "undefined" &&
      chosenAmount !== "" &&
      this.model.get("amount.chosen") !== Number(chosenAmount)
    ) {
      if (
        Number(chosenAmount) != this.model.attributes.amount.original ||
        this.model.attributes.amount.original > 0
      ) {
        if (!$(parentId).hasClass("activated")) {
          $(parentId).addClass("activated");
        }
      } else {
        $(parentId).removeClass("activated");
      }
      this.model.set("warning", null);
      this.model.attributes.amount.chosen = Number(chosenAmount);
      this.options.futureParentModifier.set(
        this.model.get("id"),
        this.model.attributes.amount.chosen,
      );

      if (this.model.attributes.amount.chosen < this.model.attributes.amount.original) {
        if (this.model.attributes.amount.original !== 0) {
          this.model.set("warning", "action_conflict_less_selected_than_before");
        }
      }
      this.options.overview._saveData();

      this.render();

      this.model.trigger("changedWarning");
    }
  },

  initialize() {
    if (typeof this.model.attributes.warning !== "undefined") return;

    const that = this;

    let available =
      typeof this.model.get("contingent_numbers") !== "undefined"
        ? typeof this.model.get("contingent_numbers")[0] !== "undefined"
          ? this.model.get("contingent_numbers")[0].number
          : 0
        : 0;

    if (available == "Contingent is not available") {
      available = 0;
    }

    // Set default state
    // These attributes will be reset in ContingentOverviewList.initialize()
    this.model.set({
      amount: {
        available,
        chosen: 0,
        original: 0,
      },
      warning: null, // UI-indicator
    });

    _.each(this.options.selectedReservationContingents, function (contingent) {
      // Map actual contingent ("original") selections from ReservationsList into model

      if (contingent.where({ baseContingentId: that.model.get("id") }).length) {
        that.model.attributes.amount.chosen = contingent.length;
        that.model.attributes.amount.original = that.model.attributes.amount.chosen;
      }
    });

    // However, if initalize() was only called as part of a re-render,
    // use its old state

    let chosen = this.options.futureParentModifier.get(this.model.get("id"));

    if (typeof chosen !== "undefined") {
      this.model.attributes.amount.chosen = chosen;
    }
  },
});

const ProductsOverviewItemProductSelect = InboomaBaseView.extend({
  template:
    typeof amount !== "undefined"
      ? _.template(`
       
    `)
      : "",

  templateContext() {
    return {
      size: FormatHelper.formatContingentTags(this.model.get("tags")),
    };
  },

  ui: {},

  events: {},

  initialize() {
    if (typeof this.model.attributes.warning !== "undefined") return;

    const that = this;
  },
});

const ProductsOverviewItem = InboomaBaseCollectionView.extend({
  // Intermediary class between productItem-frame
  // and select-boxes (= product amount's)

  template: ProductsOverviewItemTpl,
  childView: ProductsOverviewItemProductSelect,
  childViewContainer: ".products-overview-item__checkbox",
  className: "small-12 medium-4 column products-overview-item-wrapper",

  ui: {
    chosenProductInput: ".normal-product",
    changedText: ".free-text",
    chosenAmountInput: ".contingents-overview-item__chosen-amount-input",
  },

  events: {
    "click @ui.chosenProductInput": "_updateChosenProduct",
    "click .inb-text-save": "_updateChangedProduct",
    "change @ui.chosenAmountInput": "_updateChosenAmount",
  },

  templateContext() {
    return {
      product: _.first(this.collection.models),
      warning: this._warning,
      t: this.t,
    };
  },

  _onChangeWarning() {
    let warning = null;

    _.each(this.collection.models, function (product) {
      if (product.get("warning") !== null) {
        warning = product.get("warning");
      }
    });

    if (this._warning !== warning) {
      this._warning = warning;
      this.render();
    }
  },

  _updateChosenAmount() {
    const chosenAmount = this.getUI("chosenAmountInput").val();
    let parentId = "#parent_check_" + this.model.get("id");
    if (
      typeof chosenAmount !== "undefined" &&
      chosenAmount !== "" &&
      this.model.get("amount.chosen") !== Number(chosenAmount)
    ) {
      if (
        Number(chosenAmount) != this.model.attributes.amount.original ||
        this.model.attributes.amount.original > 0
      ) {
        if (!$(parentId).hasClass("activated")) {
          console.log("inside");
          $(parentId).addClass("activated");
        }
      } else {
        $(parentId).removeClass("activated");
      }
      this.model.set("warning", null);

      this.model.attributes.amount.chosen = Number(chosenAmount);
      this.options.futureParentModifier.set(
        this.model.get("id"),
        this.model.attributes.amount.chosen,
      );

      if (this.model.attributes.amount.chosen < this.model.attributes.amount.original) {
        if (this.model.attributes.amount.original !== 0) {
          this.model.set("warning", "action_conflict_less_selected_than_before");
        }
      }
      this.options.overview._saveData();

      this.render();

      this.model.trigger("changedWarning");
    }
  },

  _updateChangedProduct() {
    const parentId = "#parent_check_" + this.model.get("id");
    let chosenProduct = null;
    if (this._warning === null && this.getUI("changedText").val().trim().length > 0) {
      if (!$(parentId).hasClass("activated")) {
        $(parentId).addClass("activated");
      }

      chosenProduct = this.getUI("changedText").val();
    } else {
      $(parentId).removeClass("activated");
    }

    if (chosenProduct !== null) {
      this.model.set("warning", null);
      if (chosenProduct !== this.model.attributes.product.original) {
        this.model.set("_name", chosenProduct);
        this.model.attributes.product.chosen = chosenProduct;
        this.model.attributes.product._name = chosenProduct;
        this.options.futureParentModifierProduct.set(
          this.model.get("id").toString(),
          this.model.attributes.product.chosen,
        );
      }
      this.options.overview._saveData();
      //this.render();

      this.model.trigger("changedWarning");
    }
  },

  _updateChosenProduct() {
    let chosenProduct = null;
    if (!this.getUI("chosenProductInput").hasClass("activated") && this._warning === null) {
      this.getUI("chosenProductInput").addClass("activated");
    } else {
      this.getUI("chosenProductInput").removeClass("activated");
    }
    if (this.model.get("type") === "free") {
      if (
        $("#text_" + this.model.get("id"))
          .val()
          .trim().length < 1
      ) {
        this.model.set("warning", "no_text_is_entered");

        this.model.trigger("changedWarning");
      } else {
        chosenProduct = $("#text_" + this.model.get("id")).val();
        this.model.set("_name", chosenProduct);
        this.model.attributes.product._name = this.model.attributes.product.name = $(
          "#text_" + this.model.get("id"),
        ).val();
      }
    } else {
      chosenProduct = this.getUI("chosenProductInput").hasClass("activated");
    }

    if (chosenProduct !== null) {
      this.model.set("warning", null);
      this.model.set("_name", chosenProduct);
      this.model.attributes.product.chosen = chosenProduct;
      this.model.attributes.product._name = chosenProduct;
      this.options.futureParentModifierProduct.set(
        this.model.get("id"),
        this.model.attributes.product.chosen,
      );

      if (this.model.attributes.product.chosen < this.model.attributes.product.original) {
        if (this.model.attributes.product.original !== "") {
          this.model.set("warning", "action_conflict_less_selected_than_before");
        }
      }
      this.options.overview._saveData();
      //this.render();

      this.model.trigger("changedWarning");
    }
  },

  initialize() {
    const that = this;

    let available =
      typeof this.model.get("contingent_numbers") !== "undefined"
        ? typeof this.model.get("contingent_numbers")[0] !== "undefined"
          ? this.model.get("contingent_numbers")[0].number
          : 0
        : 0;

    if (available == "Contingent is not available") {
      available = 0;
    }
    console.log(available, "available");

    // However, if initalize() was only called as part of a re-render,
    // use its old state

    let chosen = this.options.futureParentModifier.get(this.model.get("id"));

    if (typeof chosen !== "undefined" && typeof this.model.attributes.amount !== "undefined") {
      this.model.attributes.amount.chosen = chosen;
    }

    this.model.set({
      product: {
        chosen: false,
        original: false,
      },
      amount: {
        available,
        chosen: 0,
        original: 0,
      },
      warning: null, // UI-indicator
      _name: null,
    });

    _.each(this.options.selectedReservationProducts, function (product) {
      // Map actual product ("original") selections from ReservationsList into model
      if (product.where({ productId: that.model.get("id") }).length) {
        if (that.model.get("type") === "free") {
          that.model.attributes.product._name = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
          that.model.attributes.product.chosen = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
          that.model.attributes.product.original = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
        } else {
          that.model.attributes.product.chosen = product.length;
          that.model.attributes.product.original = that.model.attributes.product.chosen;
        }
      }
    });
    _.each(this.options.selectedReservationContingents, function (contingent) {
      // Map actual contingent ("original") selections from ReservationsList into model

      if (contingent.where({ baseContingentId: that.model.get("id") }).length) {
        that.model.attributes.amount.chosen = contingent.length;
        that.model.attributes.amount.original = that.model.attributes.amount.chosen;
      }
    });
    // However, if initalize() was only called as part of a re-render,
    // use its old state

    let chosen2 = this.options.futureParentModifierProduct.get(this.model.get("id"));

    if (typeof chosen2 !== "undefined") {
      this.model.attributes.product.chosen = chosen2;
    }
    this._warning = null;

    this.collection = new Backbone.Collection();
    const _model = that.collection.add(this.model);

    // As this is runtime we need to set modelEvents manually:
    _model._rbac = {};
    _model.on("changedWarning", () => that._onChangeWarning());

    // this.render();
  },
});

/**
 * Fetch available product-ids & -numbers by begin_location
 *
 * @param {String} contingentIds
 * @param {function} callback
 * @param errorCallback
 */
const GetProductsAvailable = (contingentIds, callback, errorCallback = _.noop) => {
  const RequestHelper = Backbone.Model.extend({
    url: "/products/getRelatedProducts/" + contingentIds,
  });

  const requestHelper = new RequestHelper().fetch({
    success(model, response) {
      callback(response.related_products);
    },
    error() {
      errorCallback();
    },
  });
};

const ContingentsOverviewItem = InboomaBaseCollectionView.extend({
  // Intermediary class between contingentItem-frame
  // and select-boxes (= contingent amount's)

  template: ContingentsOverviewItemTpl,
  childView: ContingentsOverviewItemContingentSelect,
  childViewContainer: ".contingents-overview-item__amounts",
  className: "small-12 medium-4 column contingents-overview-item-wrapper fifty_percent",

  templateContext() {
    return {
      contingent: _.first(this.collection.models),
      warning: this._warning,
      t: this.t,
    };
  },

  childViewOptions() {
    return {
      selectedReservationContingents: this.options.selectedReservationContingents,
      futureParentModifier: this.options.futureParentModifier,
      overview: this.options.overview,
    };
  },

  _onChangeWarning() {
    let warning = null;

    _.each(this.collection.models, function (contingent) {
      if (contingent.get("warning") !== null) {
        warning = contingent.get("warning");
      }
    });

    if (this._warning !== warning) {
      this._warning = warning;
      this.render();
    }
  },

  initialize() {
    const that = this;

    this._warning = null;

    this.collection = new Backbone.Collection();

    _.each(this.model.attributes, function (contingent) {
      const _model = that.collection.add(contingent);

      // As this is runtime we need to set modelEvents manually:
      _model._rbac = {};
      if (typeof _model_on === "function") {
        _model.on("changedWarning", () => that._onChangeWarning());
      }
    });

    this.render();
  },
});

/**
 * Fetch available contingent-ids & -numbers by begin_location
 *
 * @param {String} begin
 * @param {String} end
 * @param {int} location_id
 * @param {int} reservation_id
 * @param {function} callback
 */
const GetContingentNumbersAvailableForLocation = (
  begin,
  end,
  location_id,
  reservation_id,
  callback,
  errorCallback = _.noop,
) => {
  const requestHelper = new (Backbone.Model.extend({
    url: "/contingents/getAvailabilityForAll",
  }))();

  if (reservation_id !== "" && reservation_id !== null) {
    requestHelper.set("reservation_id", reservation_id);
  }

  requestHelper.save(
    {
      begin: begin + (begin.length < 19 ? ":00" : ""),
      end: end + (end.length < 19 ? ":00" : ""),
      //'client_id' : Number(Biscuit.get('user.client_id')),
      location_id: location_id,
    },
    {
      success(__, data) {
        if (typeof data.success !== "undefined" && data.success === false) {
          console.log("error");
          errorCallback();
        } else {
          console.log("avail succ.: ", data);
          let tempData = data.data,
            newData = {};
          _.each(tempData.locations[0].contingents, function (contingent) {
            let id = contingent.id;
            newData[id.toString()] = contingent.available;
          });
          callback(newData);
        }
      },
      error() {
        errorCallback();
      },
    },
  );
};

export default InboomaBaseCollectionView.extend({
  el: "#contingents-overview-modal",
  childView: ContingentsOverviewItem,
  childViewContainer: "#contingents-overview__list",
  template: ContingentsOverviewModalTpl,
  _overviewTabs: [
    { id: "overview-contingents-edit", saved: true, exists: false },
    { id: "overview-products-edit", saved: true, exists: false },
  ],

  templateContext() {
    return {
      t: this.t,
      begin: moment(this.options.begin),
      end: moment(this.options.end),
      begin_location: this.options.begin_location,
      end_location: this.options.end_location,
      isHiddenElement: (id) => {
        let cm = getContentModifications();
        if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
          for (var i = 0; i < cm.hidden_elements.length; i++) {
            if (cm.hidden_elements[i] == id) return true;
          }
        }
        return false;
      },
    };
  },

  childViewOptions() {
    return {
      selectedReservationContingents: this.options.parentReservation.model.get("summedContingents"),
      futureParentModifier: this.futureParentModifier,
      selectedReservationProducts: this.options.parentReservation.model.get("summedProducts"),
      futureParentModifierProduct: this.futureParentModifierProduct,
      overview: this,
    };
  },

  ui: {
    saveBtn: "#contingents-overview__save",
    closeBtn: "#contingents-overview__close",
    searchField: "#contingents-overview__search input",
  },

  events: {
    "click @ui.saveBtn": "_saveContingentsToReservation",
    "click @ui.closeBtn": "_saveContingentsToReservation",
    "keyup @ui.searchField": "_filterCollectionByQuery",
    "click .overview-bar": "_editOverviewTabClicked",
    "click .inb-overview-close": "_closeOverviewTabClicked",
  },

  _closeWindow() {
    this._allowClose = true;

    if (typeof this.modal !== "undefined") {
      this.modal.close();
    } else {
      this._close();
    }
  },

  _close() {
    if (this._allowClose) {
      this.unbind();
      this.undelegateEvents();
      this.unbindEvents();
      this.unbindUIElements();
      this.$el.off("closed.zf.reveal");
      delete this.futureParentModifier;
      //  delete that.modal;
    } else {
      this.modal.open();
    }
  },

  initialize() {
    this._allowClose = false;

    const that = this;

    this.$el.on("closed.zf.reveal", () => {
      that._close();
    });
    that.modal = new Foundation.Reveal(this.$el, {
      closeOnEsc: false,
      closeOnClick: false,
      multipleOpened: true,
    });
    that.modal.open();
    // if(!$('#overview-contingents-edit').hasClass('activated') && !$('#overview-products-edit').hasClass('activated')) {
    $(".overview-contingents-edit").trigger("click");
    this._openContingentsOverview();
    //  }

    // On init:
    // Unset internally required data to enforce re-setting
    // amount-data (see ContingentsOverviewItem.initialize)
    //_.each(this.collection.models, function (model) {
    //  _.each(this.Contingents.models, function (model) {

    //  delete model.attributes.amount;
    //   delete model.attributes.selected;

    //   });

    // In this.futureParentModifier sub-views can set changes on the actual
    // contingents selecton. New, updated or removed elements
    // will be added added, updated or removed by parent reservation
    this.futureParentModifier = new Backbone.Model();

    this.futureParentModifier.on("change remove", (model) => {
      that._markSaveBtnAsComplete();
    });

    this.futureParentModifierProduct = new Backbone.Model();

    this.futureParentModifierProduct.on("change remove", (model) => {
      that._markSaveBtnAsComplete();
    });
  },

  _openProductsOverview() {
    const that = this;
    console.log("open products");
    this.childView = ProductsOverviewItem;
    this.childViewContainer = "#products-overview__list";
    this.template = ContingentsOverviewModalTpl;

    const locations = Radio.channel("dynamo_start_locations").request("get:data");

    this.collection = new Backbone.Collection();
    this.Products = new Products();

    let beginLocation = locations.find({
      begin_location_id: Number(that.options.begin_location.get("begin_location_id")),
    });
    console.log("beginLoc: ", beginLocation);
    /* if(this.c_tab === true){
             that.modal = new Foundation.Reveal(this.$el, {
                 closeOnEsc: false,
                 closeOnClick: false,
                 multipleOpened: true
             });
             that.modal.open();
             this.c_tab = false;
         }*/
    /*if(typeof this.futureParentModifier !== 'undefined') {
            this._saveData();
        }*/

    let contingentIds = "";
    let dynamoContingents = null;
    let dynamoExtraProducts = null;
    if (typeof beginLocation == "undefined") {
      beginLocation = locations.find({
        location_id: Number(that.options.begin_location.get("location_id")),
      });
      this.options.beginLoc = this.options.begin_location.get("location_id");
      dynamoContingents = beginLocation.attributes.contingents;
      dynamoExtraProducts = beginLocation.attributes.extra_products;
    } else {
      this.options.beginLoc = Number(this.options.begin_location.get("begin_location_id"));
      dynamoContingents =
        beginLocation.attributes.end_locations[that.options.end_location.get("begin_location_id")]
          .contingents;
      dynamoExtraProducts =
        beginLocation.attributes.end_locations[that.options.end_location.get("begin_location_id")]
          .extra_products;
    }
    let counter = 0;
    _.each(dynamoExtraProducts, function (products, mmm) {
      _.each(products, function (item, id) {
        if (typeof item.related_contingents === "undefined" && item.price_type !== "contingents") {
        }
      });
      counter++;
    });
    let c = 0;
    let initialized = false;
    that.baseCollection = that.collection.clone();
    GetContingentNumbersAvailableForLocation(
      this.options.begin,
      this.options.end,
      this.options.beginLoc,
      this.options.parentReservation.model.get("id"),
      (contingentIdHasAmount) => {
        let groupedProductsEnhanced = {};
        const _checkForCollectionIterationComplete = () => {
          // Similar to dependencies.js we ensure that (a)sync calls
          // to collection.add have been finalized, then render()
          if (_.size(groupedProductsEnhanced) == _.size(dynamoExtraProducts) || counter === c) {
            //  if(counter === c){
            const filterableCollection = that.collection.clone();
            filterableCollection.comparator = function (model) {
              return model.get("sort_order");
            };
            filterableCollection.sort();
            that.collection = new Obscura(filterableCollection);
            const filterableCollection2 = that.baseCollection.clone();
            filterableCollection2.comparator = function (model) {
              return model.get("sort_order");
            };
            filterableCollection2.sort();
            that.baseCollection = new Obscura(filterableCollection2);
            /* if(typeof that.modal === 'undefined') {
                            that.modal = new Foundation.Reveal(this.$el, {
                                closeOnEsc: false,
                                closeOnClick: false,
                                multipleOpened: true
                            });
                        }*/
            InboomaBaseCollectionView.prototype.initialize.apply(that);
            initialized = true;
            that.render();

            $("#overview-contingents-edit").attr(
              "class",
              "overview-bar _button round small hollow",
            );
            $("#overview-products-edit").attr(
              "class",
              "overview-bar _button round small hollow activated",
            );

            // Problem on re-rendering: Old animation transition attr still existent
            // this refs #19930
            that.$el.attr("class", "reveal large");
            //  that.modal.open();
            //that.collection = new Backbone.Collection();
          }
        };

        /**
         * @param {Number} contingent_id Contingent to search for in one of the groups
         * @return {Object} Grouped contingents with different sizes and ID's
         */
        const _getGroupedContingentWithSizesFromDynamo = function (needle) {
          let result;
          _.each(dynamoExtraProducts, function (_contingents, _contingent_name) {
            if (typeof result !== "undefined") return;

            if (typeof _contingents[needle] !== "undefined") {
              // Add contingent key (__contingent_id) to __contingent.attributes
              _.each(_contingents, function (__contingent, __contingent_id) {
                __contingent["id"] = Number(__contingent_id);
              });
              result = _contingents;
            }
          });

          /*if (typeof result === 'undefined') {
                        console.log('DEBUG - OverviewList - no result for', dynamoContingents, needle);
                    }*/

          return result;
        };

        // --- Let's start!
        let groupedProducts = {};
        _.each(contingentIdHasAmount, (amount, contingent_id) => {
          let contingentInList = that.Contingents.get(Number(contingent_id));

          if (typeof contingentInList == "undefined") {
            // Contingent not yet in one of the previously scanned groups

            groupedProducts = _getGroupedContingentWithSizesFromDynamo(Number(contingent_id));
            if (typeof groupedProducts == "undefined" || _.isEmpty(groupedProducts)) {
              _checkForCollectionIterationComplete();
              return;
            }

            _.each(groupedProducts, function (contingent) {
              /*if (amount == 'Contingent is not available') {
                                _checkForCollectionIterationComplete();
                                return;
                            }*/
              // Add available amount to be rendered in ContingentsOverviewItemContingentSelect,
              // then add contingent to local (flat) collection for later use
              contingent.contingent_numbers = [
                {
                  number: contingentIdHasAmount[contingent.id],
                },
              ];
              if (typeof contingent.picture !== "undefined") {
                contingent.image = contingent.picture;
              }
              let select = false;
              _.each(
                that.options.parentReservation.model.get("summedContingents"),
                function (cont, id) {
                  if (typeof contingent.related_contingents === "undefined") {
                    select = true;
                  } else {
                    _.each(contingent.related_contingents, function (contingent, c_idat) {
                      if (Number(contingent.contingent_id) === Number(id)) {
                        select = true;
                      }
                    });
                  }
                },
              );

              groupedProductsEnhanced[contingent.id] = contingent;
              that.Products.add(contingent);
              that.Contingents.add(contingent);
              if (!initialized) {
                that.collection.add([contingent]);
              }
              //c++;
            });
            c++;

            // Add grouped contingents to main collection
            // (for rendering only)
          }

          // 'r we done yet?
          _checkForCollectionIterationComplete();
        });

        _.each(dynamoExtraProducts, function (_products, _product_name) {
          _.each(_products, function (product, id) {
            if (product.price_type === "product") {
              let productInList = that.Products.get(Number(id));
              let select = false;
              _.each(
                that.options.parentReservation.model.get("summedContingents"),
                function (cont, id) {
                  if (typeof product.related_contingents === "undefined") {
                    select = true;
                  } else {
                    _.each(product.related_contingents, function (contingent, c_idat) {
                      select = true; //EVIL !!!!!!!!!!!!!!!
                      if (Number(contingent.contingent_id) === Number(id)) {
                        select = true;
                      }
                    });
                  }
                },
              );
              if (!select) {
                if (typeof product.related_contingents === "undefined") {
                  select = true;
                }
              }

              if (typeof productInList == "undefined" && select) {
                // Product not yet in one of the previously scanned groups
                product.id = id;
                if (typeof product.picture !== "undefined") {
                  product.image = product.picture;
                }
                that.Products.add(product);
                groupedProductsEnhanced[id] = product;
                if (!initialized) {
                  that.collection.add([product]);
                }
              } else if (!select) {
                groupedProductsEnhanced[id] = {};
              }
              c++;
            }
          });
          if (!initialized) {
            that.baseCollection.add([groupedProductsEnhanced]);
          }
          _checkForCollectionIterationComplete();
        });
      },
      () => {
        // Error callback

        new Notification({
          message: that.t("no_products_available"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });

        that._allowClose = true;
        that._closeWindow();
      },
    );
  },

  _openContingentsOverview() {
    /* if(typeof this.futureParentModifierProduct !== 'undefined') {
            this._saveData();
        }
*/
    const that = this;

    this.collection = new Backbone.Collection();
    this.Contingents = new Contingents();
    this.childView = ContingentsOverviewItem;
    this.template = ContingentsOverviewModalTpl;
    this.childViewContainer = "#contingents-overview__list";
    const locations = Radio.channel("dynamo_start_locations").request("get:data");
    console.log("locs: ", locations);
    let beginLocation = locations.find({
      begin_location_id: Number(that.options.begin_location.get("begin_location_id")),
    });
    let dynamoContingents = null;
    let dynamoExtraProducts = null;
    if (typeof beginLocation == "undefined") {
      beginLocation = locations.find({
        location_id: Number(that.options.begin_location.get("location_id")),
      });
      this.options.beginLoc = this.options.begin_location.get("location_id");
      dynamoContingents = beginLocation.attributes.contingents;
      dynamoExtraProducts = beginLocation.attributes.extra_products;
    } else {
      this.options.beginLoc = Number(this.options.begin_location.get("begin_location_id"));
      dynamoContingents =
        beginLocation.attributes.end_locations[that.options.end_location.get("begin_location_id")]
          .contingents;
      dynamoExtraProducts =
        beginLocation.attributes.end_locations[that.options.end_location.get("begin_location_id")]
          .extra_products;
    }
    console.log("dynCont: ", dynamoContingents);
    GetContingentNumbersAvailableForLocation(
      this.options.begin,
      this.options.end,
      this.options.beginLoc,
      this.options.parentReservation.model.get("id"),
      (contingentIdHasAmount) => {
        let c = 0;

        const _checkForCollectionIterationComplete = () => {
          // Similar to dependencies.js we ensure that (a)sync calls
          // to collection.add have been finalized, then render()
          if (++c == _.size(contingentIdHasAmount)) {
            const filterableCollection = that.collection.clone();
            filterableCollection.comparator = function (model) {
              let sort_order = 99999;
              _.each(model.attributes, function (attr) {
                sort_order = attr.sort_order;
              });
              return sort_order;
            };
            filterableCollection.sort();
            that.collection = new Obscura(filterableCollection);
            if (typeof that.modal === "undefined") {
              that.modal = new Foundation.Reveal(this.$el, {
                closeOnEsc: false,
                closeOnClick: false,
                multipleOpened: true,
              });
            }
            InboomaBaseCollectionView.prototype.initialize.apply(that);

            that.render();
            $("#overview-products-edit").attr("class", "overview-bar _button round small hollow");
            $("#overview-contingents-edit").attr(
              "class",
              "overview-bar _button round small hollow activated",
            );

            // Problem on re-rendering: Old animation transition attr still existent
            // this refs #19930
            that.$el.attr("class", "reveal large");

            //   that.modal.open();
          }
        };

        /**
         * @param {Number} contingent_id Contingent to search for in one of the groups
         * @return {Object} Grouped contingents with different sizes and ID's
         */
        const _getGroupedContingentWithSizesFromDynamo = function (needle) {
          let result;
          _.each(dynamoContingents, function (_contingents, _contingent_name) {
            if (typeof result !== "undefined") return;

            if (typeof _contingents[needle] !== "undefined") {
              // Add contingent key (__contingent_id) to __contingent.attributes
              _.each(_contingents, function (__contingent, __contingent_id) {
                __contingent["id"] = Number(__contingent_id);
              });
              result = _contingents;
            }
          });

          /*if (typeof result === 'undefined') {
                        console.log('DEBUG - OverviewList - no result for', dynamoContingents, needle);
                    }*/

          return result;
        };

        // --- Let's start!

        _.each(contingentIdHasAmount, (amount, contingent_id) => {
          /*if (amount == 'Contingent is not available') {
                        _checkForCollectionIterationComplete();
                        return;
                    }*/
          console.log("cont. id: ", contingent_id);
          let contingentInList = that.Contingents.get(Number(contingent_id));

          if (typeof contingentInList == "undefined") {
            // Contingent not yet in one of the previously scanned groups

            const groupedContingents = _getGroupedContingentWithSizesFromDynamo(
              Number(contingent_id),
            );

            if (typeof groupedContingents == "undefined" || _.isEmpty(groupedContingents)) {
              _checkForCollectionIterationComplete();
              return;
            }

            _.each(groupedContingents, function (contingent) {
              // Add available amount to be rendered in ContingentsOverviewItemContingentSelect,
              // then add contingent to local (flat) collection for later use
              contingent.contingent_numbers = [
                {
                  number: contingentIdHasAmount[contingent.id],
                },
              ];

              that.Contingents.add(contingent);
            });

            // Add grouped contingents to main collection
            // (for rendering only)
            that.collection.add([groupedContingents]);
          }

          // 'r we done yet?
          _checkForCollectionIterationComplete();
        });
      },
      () => {
        // Error callback

        new Notification({
          message: that.t("no_contingents_available"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });

        that._allowClose = true;
        that._closeWindow();
      },
    );
  },
  /*
   * this simply opens / shows the order tab
   * without doing anything else
   */
  _openOverviewTab(tabElement) {
    $(tabElement).removeClass("inactive");
    $(tabElement).addClass("active");
    $(this._getContentBoxOfOverviewTab(tabElement)).removeClass("hide");
  },

  /*
   * this closes / hides a tab if tab is saved or user confirms closing
   */
  _closeOverviewTab(tabElement, callback) {
    var closed = true;

    for (var i = 0; i < this._overviewTabs.length; i++) {
      if (!this._overviewTabs[i].saved && this._overviewTabs[i].id == tabElement.id) {
        // tab has unsaved changes
        var that = this;
        if (confirm("Achtung, Änderungen werden hiermit verworfen! Fortfahren?")) {
          // reset tab
          that._updateOverviewAddresses();
        } else {
          closed = false;
        }
      }
    }
    if (closed) {
      $(this._getContentBoxOfOverviewTab(tabElement)).addClass("hide");
      $(tabElement).removeClass("active");
    }
    if (typeof callback === "function") callback(closed);
  },

  // simply returns the container of the content that belongs to the tab
  _getContentBoxOfOverviewTab(tabElement) {
    switch (tabElement.id) {
      case "overview-contingents-edit":
        return this._openContingentsOverview();
      case "overview-products-edit":
        return this._openProductsOverview();
    }
  },

  // simply returns the tab bar element that belongs to the tab content box
  _getOverviewtabOfContentBox(contentBox) {
    switch (contentBox.id) {
      case "order-form-invoice-address":
        return document.getElementById("overview-contingents-edit");
      case "order-form-start-address":
        return document.getElementById("order-form-start-address-edit");
      case "order-form-end-address":
        return document.getElementById("order-form-end-address-edit");
      case "order-form-tags-container":
        return document.getElementById("order-form-tags-edit");
    }
  },

  // return the currently opened tab or null if no tab is open
  _getOpenOverviewTab() {
    const tabContainer = document.getElementById("overview-container");
    for (var elem, i = 0; i < tabContainer.childNodes.length; i++) {
      elem = tabContainer.childNodes[i];
      if (elem.tagName == "DIV" && $(elem).hasClass("overview-bar") && $(elem).hasClass("active")) {
        return elem;
      }
    }
    return null;
  },

  _editOverviewTabClicked(ev) {
    ev.stopImmediatePropagation();

    // get the right order tab
    let tab = ev.target.parentNode;
    if ($(ev.target).hasClass("overview-bar")) tab = ev.target;

    // proof if tab is already open
    if ($(tab).hasClass("active")) return;

    var openTab = this._getOpenOverviewTab();
    if (openTab == null) {
      // no tab open - open new tab

      this._openOverviewTab(tab);
    } else {
      // try to close tab (maybe there are unsaved changed and user aborts)
      var that = this;
      this._closeOverviewTab(openTab, function (closed) {
        console.log("tried to close order tab: ", closed);
        if (closed) {
          that._openOverviewTab(tab);
        }
      });
    }
  },

  _closeOverviewTabClicked(ev) {
    console.log("close address");
    ev.stopImmediatePropagation();

    // get right tab element
    var contentBox = ev.target.parentNode.parentNode;
    if ($(ev.target).hasClass("fi") || $(ev.target).hasClass("inb-icon"))
      contentBox = contentBox.parentNode;

    var tabElement = this._getOverviewtabOfContentBox(contentBox);
    this._closeOverviewTab(tabElement);
  },

  _filterCollectionByQuery() {
    const query = this.getUI("searchField").val().toLowerCase();

    this.getUI("searchField").parent().find(".inb-input--search-reset").fadeIn("fast");

    if (query.length >= 2) {
      this.collection.filterBy("query", (contingentGroup) => {
        const _contingent = contingentGroup.attributes[Object.keys(contingentGroup.attributes)[0]];
        return _contingent.name.toLowerCase().indexOf(query) >= 0;
      });
    } else if (query.length <= 1) {
      this.collection.removeFilter("query");
    }
  },

  _markSaveBtnAsUncomplete() {
    const saveBtn = this.$el.find(this.ui["saveBtn"]);

    saveBtn.removeClass("beautify").addClass("hollow");
  },

  _markSaveBtnAsComplete() {
    const saveBtn = this.$el.find(this.ui["saveBtn"]);

    saveBtn.removeClass("hollow").addClass("beautify");
  },

  _saveData() {
    let added = 0,
      deleted = 0;

    const that = this;

    _.each(
      this.options.parentReservation.model.get("summedContingents"),
      function (collection, contingentId) {
        // -- Option I --
        // Modify the numbers of a contingent that has already
        // been selected in ReservationContingentsList

        const soll = that.futureParentModifier.get(contingentId);
        if (typeof soll !== "undefined") {
          if (soll == 0) {
            // -- Option I.I --
            // Unset original contingent completely
            for (
              let i = 0;
              i <
              that.options.parentReservation.model.attributes.summedContingents[contingentId].models
                .length;
              i++
            ) {
              deleted++;
            }
            while (soll < collection.models.length) {
              collection.remove(collection.models[collection.models.length - 1]);
            }

            delete that.options.parentReservation.model.attributes.summedContingents[contingentId];
            that.options.parentReservation.model.trigger("removedContingent", contingentId);
          } else if (soll < collection.models.length) {
            // -- Option I.II --
            // Reduce model(s) from original contingent
            while (soll < collection.models.length) {
              collection.remove(collection.models[collection.models.length - 1]);
              deleted++;
            }
          } else if (soll > collection.models.length) {
            // -- Option I.III --
            // Add model(s) to original contingent
            while (soll > collection.models.length) {
              const random = Math.floor(Math.random() * Math.floor(2000)),
                clone = collection.models[collection.models.length - 1].clone();

              clone.attributes.id += random;
              delete clone.attributes.order_item_price_id; // keeps this id empty for new contingents, contingents should not have the same id
              collection.add(clone);

              added++;
            }
          }

          delete that.futureParentModifier.attributes[contingentId];
        }
      },
    );

    let summedContingents = that.options.parentReservation.model.get("summedContingents");

    _.each(this.futureParentModifier.attributes, function (amount, contingentId) {
      // -- Option II --
      // Contingent was selected that is not yet in scope of reservation

      let contingent = that.Contingents.get(contingentId);

      contingent.attributes.rab_parent_id = Number(contingent.attributes.external_contingent_id);
      contingent.attributes.manual_override = false;

      for (let i = 0; i < amount; i++) {
        // Same as in ReservationsList::initialize()
        if (typeof summedContingents[contingent.id] == "undefined") {
          summedContingents[contingent.id] = new Contingents(contingent);
        } else {
          // Clone contingent WITHOUT previous id, WITHOUT reference
          const clone = contingent.clone();
          clone.set("baseContingentId", clone.id); // @todo Put EITHER here OR in ReservationContingentsList

          delete clone.attributes.id;

          summedContingents[contingent.id].add(clone, { trigger: false });
        }

        added++;
      }

      that.options.parentReservation.model.set("summedContingents", summedContingents);
      that.options.parentReservation.model.trigger("change:summedContingents");
    });

    let message = added >= 1 ? this.t("unit_added") + "\n" : "";
    message += deleted >= 1 ? this.t("unit_deleted") + "\n" : "";

    _.each(
      this.options.parentReservation.model.get("summedProducts"),
      function (collection, productId) {
        // -- Option I --
        // Modify the numbers of a product that has already
        // been selected in ReservationProductsList
        const soll = that.futureParentModifierProduct.get(productId);

        if (typeof soll !== "undefined") {
          if (soll == false) {
            // -- Option I.I --
            // Unset original product completely
            deleted++;
            delete that.options.parentReservation.model.attributes.summedProducts[productId];
            that.options.parentReservation.model.trigger("removedProduct", productId);
            delete that.futureParentModifierProduct.attributes[productId];
          }
        }
      },
    );

    let summedProducts = that.options.parentReservation.model.get("summedProducts");

    _.each(this.futureParentModifierProduct.attributes, function (value, productId) {
      // -- Option II --
      // Product was selected that is not yet in scope of reservation
      if (productId.includes("_")) {
        let help = productId.split("_");
        productId = help[0];
      }

      let product = that.Products.get(productId);
      if (product.attributes.type === "free" && typeof summedProducts[product.id] == "undefined") {
        product.attributes.description = value;
      }
      product.attributes.manual_override = false;

      if (typeof summedProducts[product.id] == "undefined") {
        summedProducts[product.id] = new Products(product);
      } /*else {
                // Clone product WITHOUT previous id, WITHOUT reference
                const clone = product.clone();
                clone.set('baseContingentId',clone.id); // @todo Put EITHER here OR in ReservationContingentsList
                if(clone.attributes.type === 'free'){
                    clone.attributes.description = value;
                }
                delete clone.attributes.id;

                summedProducts[product.id].add(clone, { trigger:false });
            }*/
      added++;

      that.options.parentReservation.model.set("summedProducts", summedProducts);
      that.options.parentReservation.model.trigger("change:summedContingents");
    });

    message = added >= 1 ? this.t("unit_added") + "\n" : "";
    message += deleted >= 1 ? this.t("unit_deleted") + "\n" : "";

    if (message !== "") {
      new Notification({
        message,
        duration: 5000,
        closeable: true,
        icon: "fi fi-check",
      });

      this.options.parentReservation.onChangeObserver.call(this.options.parentReservation);
    }
  },

  _saveContingentsToReservation() {
    // Finally compare local selection with original collection,
    // then modify the latter one
    // this._saveData();

    this._allowClose = true;
    this.unbind();
    this.undelegateEvents();
    this.unbindEvents();
    this.unbindUIElements();
    this.$el.off("closed.zf.reveal");
    delete this.futureParentModifier;
    this.modal.close();

    //$('.reveal-overlay').css('display','none');
  },
});
